import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToastMessage, ToastService } from '../../core/services/toast.service';

@Component({
	selector: 'app-toast',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ToastComponent implements OnInit, OnDestroy {
	public queue: ToastMessage[] = [];

	private subscription: Subscription;

	constructor(
		public ts: ToastService,
	) { }

	ngOnInit() {
		this.subscription = this.ts.queue$.subscribe((data) => {
			this.queue = data;
		});
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
	}

	dismiss(id: number) {
		this.ts.removeMessage(id);
	}

	trackById(_index: number, toast: ToastMessage) {
		return toast.id;
	}
}
